export default __webpack_public_path__ + "static/media/junk4.a4d210a7.svg";